import React from 'react';
import axios from 'axios';
import { Button } from '../ui/button';
import { Download, Upload } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const BackupSection = ({ onSuccess, onError }) => (
  <div className="bg-[#121212] border border-[#27272A] p-6">
    <h3 className="text-lg font-semibold uppercase mb-5" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
      Backup Dati
    </h3>
    <div className="flex flex-wrap gap-3">
      <Button
        onClick={async () => {
          try {
            const res = await axios.get(`${API_URL}/api/backup/export`, { withCredentials: true });
            const dataStr = JSON.stringify(res.data, null, 2);
            const blob = new Blob([dataStr], { type: 'application/json' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `vvf_backup_${new Date().toISOString().split('T')[0]}.json`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            onSuccess('Backup scaricato');
          } catch (err) {
            onError('Errore nel backup: ' + (err.response?.data?.detail || err.message));
          }
        }}
        className="bg-[#009246] hover:bg-[#007a3a] text-white rounded-none uppercase tracking-wide"
        data-testid="export-backup-btn"
      >
        <Download className="w-4 h-4 mr-2" />
        Esporta
      </Button>
      <label className="cursor-pointer">
        <input
          type="file"
          accept=".json"
          className="hidden"
          onChange={async (e) => {
            const file = e.target.files?.[0];
            if (!file) return;
            try {
              const text = await file.text();
              const data = JSON.parse(text);
              if (window.confirm('Sei sicuro di voler importare questo backup? I dati attuali verranno sovrascritti.')) {
                await axios.post(`${API_URL}/api/backup/import`, data, { withCredentials: true });
                onSuccess('Backup importato con successo');
              }
            } catch (err) {
              onError("Errore nell'importazione: " + (err.response?.data?.detail || err.message));
            }
          }}
          data-testid="import-backup-input"
        />
        <span className="bg-[#1A1A1A] border border-[#333333] hover:border-[#E3000F] text-white px-6 py-3 uppercase tracking-wide flex items-center gap-2 transition-colors cursor-pointer">
          <Upload className="w-4 h-4" />
          Importa
        </span>
      </label>
    </div>
  </div>
);
